module.exports = __webpack_public_path__ + "img/we-will-fix-it-new.f0331736.png";